import { Box, Typography } from "@mui/material";
import Stack from '@mui/material/Stack';
import fotka from '../images/ryfoldzani.jpg';


const About = () => {



    return(
        <Stack 
            justifyContent="center"
            alignItems="left"
            spacing = {2}
            sx={{ margin: 2 }}
            >
            <Typography variant="h5">O nás</Typography>

            <Typography variant="body"><strong>Ľudovú hudbu Ryfoldzani </strong> 
                tvoria dvaja muzikanti z Veľkej Lesnej. Peter hrá 
                na harmonike a Jozef na kontrabase. Spoločne sa venujeme
                hraniu ľudovej hudby na oslavách či akciách už veľa rokov.
            </Typography>
            <Typography variant="body">
                Nájdete nás aj na našej 
                <a href="https://www.facebook.com/profile.php?id=61556349782048"> facebookovej stránke Ľudová hudba Ryfoldzani</a>
            </Typography>

            <img src={fotka} alt="fotka" />
            <Typography variant="h5">Kontakt</Typography>
            
            <Typography variant="body">V prípade akýchkoľvek otázok či objednávky hrania nás môžete kontakovať na týchto
            telefónnych číslach: </Typography>
               
            <Typography variant="body"><a href="tel:+421905249468">+421 905 249 468</a> - Jozef</Typography>
            <Typography variant="body"><a href="tel:+421903639632">+421 903 639 632</a> - Peter</Typography>
                
            
        </Stack>
    )
}
export default About;